// Main path on server
export const pathHomePage = "";
// Main youtube path
export const youtubeLink = "https://www.youtube.com/embed";

// Projects: global - strack
export const project = "global";

// Environments: production - beta - development
const environment = "production";
const WEB_SERVICE = {
  global: `https://rgsweb.eodyne.com/rgsmims/backend/${environment}/webservices/src`,
  strack: `https://rgsweb.eodyne.com/rgsmims/backend/strack/${environment}/src`,
};
export const WEB_SERVICE_ROUTE = WEB_SERVICE[project];
export const WEB_SERVICE_MIMS = `${WEB_SERVICE_ROUTE}/mims`;

export const primaryColor = "#26A9B6";
export const primaryColorHover = "#1A737B";
export const errorColor = "#D9434E";
export const bodyColor = "#E6E6E6";
export const graphicDataColor1 = "#4DC4FF";
export const graphicDataColor2 = "#EE4D4D";
export const graphicDataColor3 = "#39b54a";
export const graphicDataColor4 = "#6666FF";
export const graphicDataColor5 = "#f15a24";
export const AdherenceColorLow = "#ed1c24";
export const AdherenceColorMedium = "#fbb03b";
export const AdherenceColorHigh = "#39b54a";
export const colorsArray = [
  "#4DC4FF",
  "#EE4D4D",
  "#39b54a",
  "#FDF201",
  "#004FA2",
  "#FF0E4B",
  "#FEB416",
  "#5D2D91",
  "#00AEF0",
  "#00A66C",
  "#F37520",
  "#303092",
  "#EB0089",
  "#A6CE3B",
  "#0072BB",
  "#E8371F",
  "#00A99E",
  "#92278F",
  "#FF6633",
  "#1AFF33",
  "#6666FF",
  "#E6B333",
];
export const prescriptionColors1 = {
  MONDAY: "#F96C51",
  TUESDAY: "#FECD56",
  WEDNESDAY: "#9ED36B",
  THURSDAY: "#56BEC6",
  FRIDAY: "#6499D2",
  SATURDAY: "#A390C4",
  SUNDAY: "#E486B6",
};
export const prescriptionColors2 = {
  MONDAY: "#E69F00",
  TUESDAY: "#0072B2",
  WEDNESDAY: "#F0E442",
  THURSDAY: "#CC79A7",
  FRIDAY: "#009E73",
  SATURDAY: "#D55E00",
  SUNDAY: "#56B4E9",
};

export const pathologies = {
  otherId: 9,
  alzheimerId: 1,
  ataxiaId: 2,
  cerebralPalsyId: 3,
  multipleSclerosisId: 4,
  parkinsonId: 5,
  spinalCordInjuryId: 6,
  strokeId: 7,
  traumaticBrainInjuryId: 8,
};

export const applications = {
  clinic: {
    id: 1,
    name: "clinic",
  },
  home: {
    id: 2,
    name: "home",
  },
  web: {
    id: 3,
    name: "web",
  },
  app: {
    id: 4,
    name: "app",
  },
  wear: {
    id: 5,
    name: "wear",
  },
  icu: {
    id: 6,
    name: "icu",
  },
  plus: {
    id: 7,
    name: "plus",
  },
};

export const protocols = {
  clinicAndHome: {
    SPHEROIDS: {
      id: 10,
      isActive: true,
    },
    PINBALL: {
      id: 40,
      isActive: true,
    },
    HOCKEY: {
      id: 50,
      isActive: true,
    },
    CLEAN_THE_TABLE: {
      id: 60,
      isActive: true,
    },
    GRASP_AND_PLACE: {
      id: 90,
      isActive: true,
    },
    FOLLOW_THE_LINE: {
      id: 100,
      isActive: true,
    },
    ROAD_TRIP: {
      id: 110,
      isActive: true,
    },
    BRICKS: {
      id: 120,
      isActive: true,
    },
    BOAT: {
      id: 140,
      isActive: true,
    },
    BUBBLES: {
      id: 151,
      isActive: true,
    },
    DEMOLITION: {
      id: 152,
      isActive: true,
    },
    CATERING: {
      id: 153,
      isActive: true,
    },
    CONSTELLATIONS: {
      id: 80,
      isActive: true,
    },
    TWISTER_BUDDY: {
      id: 309,
      isActive: true,
    },
    COSTUME_PARTY: {
      id: 310,
      isActive: true,
    },
    GENTLE_GIANT: {
      id: 311,
      isActive: true,
    },
  },
  app: {
    basic: {
      MEMOSEQ: {
        id: 201,
        isActive: true,
      },
      PLACE_IT: {
        id: 204,
        isActive: true,
      },
      GUESS_WHAT: {
        id: 202,
        isActive: true,
      },
      PIANOSEQ: {
        id: 203,
        isActive: true,
      },
      BLOBS: {
        id: 214,
        isActive: true,
      },
      SHOPPING: {
        id: 215,
        isActive: true,
      },
      POPURRI: {
        id: 222,
        isActive: true,
      },
      TWISTER: {
        id: 223,
        isActive: true,
      },
      MEMORY: {
        id: 224,
        isActive: true,
      },
      CLEANING: {
        id: 216,
        isActive: true,
      },
      CONSTELLATIONS: {
        id: 229,
        isActive: false,
      },
      BALLOONS_BASIC: {
        id: 231,
        isActive: true,
      },
      QUALITY_CONTROL_BASIC: {
        id: 232,
        isActive: false,
      },
    },
    rotation: {
      ARMANOID: {
        id: 211,
        isActive: true,
      },
      DRIVING: {
        id: 217,
        isActive: true,
      },
    },
    ar: {
      TRAINING: {
        id: 200,
        isActive: true,
      },
      SHELVES: {
        id: 208,
        isActive: true,
      },
      BUFFET: {
        id: 210,
        isActive: true,
      },
      ALPHABET: {
        id: 205,
        isActive: true,
      },
      BALLOONS: {
        id: 206,
        isActive: true,
      },
      DUCKS: {
        id: 209,
        isActive: true,
      },
      SPHEROIDS: {
        id: 218,
        isActive: true,
      },
      HOCKEY: {
        id: 219,
        isActive: true,
      },
      CIRCLE: {
        id: 220,
        isActive: false,
      },
      WHAC_A_MOLE: {
        id: 221,
        isActive: true,
      },
      TUBES: {
        id: 226,
        isActive: true,
      },
      CLEANING_AR: {
        id: 225,
        isActive: true,
      },
      CLEANING_AR_VERTICAL: {
        id: 227,
        isActive: true,
      },
      CIRCLE_HORIZONTAL: {
        id: 228,
        isActive: false,
      },
      QUALITY_CONTROL: {
        id: 230,
        isActive: true,
      },
      CONSTELLATIONS_AR: {
        id: 233,
        isActive: true,
      },
    },
  },
  web: {
    handTracking: {
      MEMOSEQ: {
        id: 301,
        isActive: true,
      },
      MIRROR: {
        id: 302,
        isActive: true,
      },
      RECYCLING: {
        id: 303,
        isActive: true,
      },
      WHAC_A_MOLE: {
        id: 304,
        isActive: true,
      },
      FULL_BODY: {
        id: 305,
        isActive: false,
      },
      BALANCE: {
        id: 306,
        isActive: false,
      },
      SEQUENCES: {
        id: 307,
        isActive: true,
      },
      WORDS: {
        id: 308,
        isActive: true,
      },
      OBJECTS_RAIN: {
        id: 234,
        isActive: true,
      },
    },
    fullBody: {
      TWISTER_BUDDY: {
        id: 309,
        isActive: true,
      },
      COSTUME_PARTY: {
        id: 310,
        isActive: true,
      },
      GENTLE_GIANT: {
        id: 311,
        isActive: true,
      },
    },
  },
  icu: {
    THE_GARDEN: {
      id: 401,
      isActive: true,
    },
    THE_BEACH: {
      id: 402,
      isActive: true,
    },
    THE_AQUARIUM: {
      id: 403,
      isActive: true,
    },
    THE_UNIVERSE: {
      id: 404,
      isActive: true,
    },
    THE_NUMBERS: {
      id: 405,
      isActive: true,
    },
    THE_RIVER: {
      id: 406,
      isActive: true,
    },
    THE_BUTTERFLIES: {
      id: 407,
      isActive: true,
    },
    WALK_AROUND_THE_ISLAND: {
      id: 408,
      isActive: true,
    },
    SUNSET_AMONG_POPPIES: {
      id: 409,
      isActive: true,
    },
    CALM_IN_THE_LAKE: {
      id: 410,
      isActive: true,
    },
    FLYING_OVER_THE_FIELDS: {
      id: 411,
      isActive: true,
    },
    RELAX_ON_THE_BEACH: {
      id: 412,
      isActive: true,
    },
    THE_SOUND_OF_WATER: {
      id: 413,
      isActive: true,
    },
    THE_SWAY_OF_THE_WAVES: {
      id: 414,
      isActive: true,
    },
  },
};

// Adherence
export const adherenceLevel = {
  lowToMedium: 50,
  mediumToHigh: 74,
};

// Company data
export const supportInfo = {
  landline: "+34 931 389 642",
  mobile: "+34 605 580 747",
  email: "contact@eodyne.com",
  web: "www.eodyne.com",
};
export const JUST4UInfo = {
  landline: "+886 2 8797 5990",
  email: "rgs.just4u@gmail.com",
  web: "https://www.just4u.tw",
};
export const strackSupportInfo = {
  mobile1: "+34 935 834 300",
  mobile2: "+34 900 300 705",
  web: "http://dialog.roche.com",
};
